import React, {useState} from "react";
import "../css/GCPillButton.css";
import "../css/signup.css";
import { useLanguage } from "../components/Language.js";
import InfoForm from './infoProfile.js';
import {BASE_URL} from "../constants"

function SignupForm({onClose}) {
    const [username, setUsername] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [postcode, setPostcode] = useState("");
    const [consent, setConsent] = useState(false);
    const [gender, setGender] = useState(3);
    const [initalLang, setInitalLang] = useState(0);
    const [ageRange, setAgeRange] = useState(0);
    const [labels, setLabels] = useState("");
    const [tourist, setTourist] = useState(false);
    const [customLabel, setCustomLabel] = useState("");
    const {language} = useLanguage();

    const translations = {
        en: {
            signUp: "Sign Up",
            username: "Username",
            password: "Password",
            email: "E-mail",
            firstName: "First Name",
            lastName: "Last Name",
            postcode: "Postcode",
            continue: "Continue",
            selectAbility: "Select your Gaelic ability",
            noAbility: "No Gaelic ability",
            beginner: "Beginner",
            intermediate: "Intermediate",
            advanced: "Advanced",
            fluent: "Fluent",
            selectGender: "Select Your Gender",
            preferNotToSay: "Prefer not to say",
            male: "Male",
            female: "Female",
            nonBinary: "Non-Binary",
            selectAge: "Select your age range",
            visiting: "Are you visiting Glasgow",
            termsAndConditionsIntro: "I accept the ",
            termsAndConditions: "terms and conditions",
            labels: "Select Labels",
            learner: "Learner",
            newSpeaker: "New Speaker",
            gmeGraduate: "GME Graduate",
            native: "Native",
            back: "Back",
            cancel: "Cancel",
            addLabel: "Add Label",
            enterLabel: "Enter a Label",
            
        },
        gd: {
            signUp: "Clàraich",
            username: "Ainm Cleachdaidh",
            password: "Facal-faire",
            email: "Post-d",
            firstName: "Ciad Ainm",
            lastName: "Sloinneadh",
            postcode: "Còd-puist",
            continue: "Lean Ort",
            selectAbility: "Tagh do chomas ann an Gàidhlig",
            noAbility: "Chan eil comas Gàidhlig sam bith",
            beginner: "Neach-tòiseachaidh",
            intermediate: "Eadar-mheadhanach",
            advanced: "Adhartach",
            fluent: "Fileanta",
            selectGender: "Tagh do ghnè",
            preferNotToSay: "B'fheàrr leam gun a ràdh",
            male: "Fireannach",
            female: "Boireann",
            nonBinary: "neo-dhinary",
            selectAge: "Tagh do raon aoise",
            visiting: "A bheil thu a' tadhail air Glaschu?",
            termsAndConditionsIntro: "Tha mi a' gabhail ris na ",
            termsAndConditions: "Cùmhnantan",
            labels: "tagh suaicheantasan",
            learner: "Neach-ionnsachaidh",
            newSpeaker: "Neach-labhairt Ùr",
            gmeGraduate: "Ceumnaiche GME",
            native: "Dùthchasach",
            back: "Air ais",
            cancel: "Dubh às",
            addLabel: "Cuir leubail",
            enterLabel: "Cuir a-steach leubail",
        },
    };


    const predefinedLabels = [translations[language].learner, translations[language].newSpeaker, translations[language].gmeGraduate, translations[language].fluent, translations[language].native];
    const [isAbilityInfoVisible, setAbilityInfoVisible] = useState(false);
    const [isLabelInfoVisible, setLabelInfoVisible] = useState(false);

    const handleLabelChange = (event) => {
        const label = event.target.value;
        if (event.target.checked) {
          setLabels([...labels, label]);
        } else {
          setLabels(labels.filter((item) => item !== label));
        }
    };

    const addCustomLabel = () => {
        if (customLabel && !labels.includes(customLabel)) {
            setLabels([...labels, customLabel]);
            setCustomLabel("");
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        const response = await fetch(`${BASE_URL}/api/signup/`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                username,
                email,
                password,
                "first_name": firstName,
                "last_name": lastName,
                "postcode": postcode,
                "consent": consent,
                "gender": gender,
                "inital_lang": initalLang,
                "tourist": tourist,
                "age_range": ageRange,
                "labels": labels,
            }),
        });

        const data = await response.json(); 

        if (data["status"] === "error") {
            console.log(data["message"]);
            let errorDiv = document.getElementById("sign-up-error");
            errorDiv.innerHTML = ''
            errorDiv.innerHTML = data["message"];
            alert(data["message"]);
        }
        else{
            alert("Account successfully created!");
            onClose();
        }

    };



    return (

        <div className="signup-form">

          <div className="signup-form">
        
          <div className="sign-up-form-header">
                <h2 className="text-center mb-3 fw-bold"> {translations[language].signUp} </h2>
                <button className= "close-x" onClick={onClose}>&times;</button> 
          </div>

            <form className="mx-2" onSubmit={handleSubmit}>

                <div id="sign-up-error" className="text-center text-danger mb-2"></div>
                   
                <div className="form-group mb-3">

                    <input
                        required
                        type="text"
                        id = "username-input"
                        placeholder= {translations[language].username}
                        value={username}
                        className="form-input form-control text-center"
                        onChange={(e) => setUsername(e.target.value)}
                    />

                </div>
                
                <div className="form-group mb-3">

                    <input
                        required
                        type="password"
                        id="password"
                        placeholder={translations[language].password}
                        value={password}
                        className="form-input form-control text-center"
                        onChange={(e) => setPassword(e.target.value)}
                    />

                </div>

                <div className="form-group mb-3">

                    <input
                        required
                        type="email"
                        id="email"
                        placeholder={translations[language].email}
                        value={email}
                        className="form-input form-control text-center"
                        onChange={(e) => setEmail(e.target.value)}
                    />

                </div>


                <div className="form-group mb-3">
                    
                    <input
                        required
                        type="text"
                        id="first_name"
                        placeholder={translations[language].firstName}
                        value={firstName}
                        className="form-input form-control text-center"
                        onChange={(e) => setFirstName(e.target.value)}
                    />

                </div>


                <div className="form-group mb-3">

                    <input
                        required
                        type="text"
                        id="last_name"
                        placeholder={translations[language].lastName}
                        value={lastName}
                        className="form-input form-control text-center"
                        onChange={(e) => setLastName(e.target.value)}
                    />

                </div>

                <div className="form-group mb-3">

                    <input
                        type="text"
                        id="Postcode: "
                        placeholder={translations[language].postcode}
                        value={postcode}
                        className="form-input form-control text-center"
                        onChange={(e) => setPostcode(e.target.value)}
                    />
                    
                </div>

                
                <div className="form-group mb-3">
                  
                    <span>{translations[language].selectAbility}: </span>

                    <div className="gaelic-ability-container">
                        <select 
                            id="Gaelic_ability"
                            value={initalLang} 
                            className="form-input form-control" 
                            onChange={(e) => setInitalLang(parseInt(e.target.value, 10))}
                        >
                            <option value="0">{translations[language].noAbility}</option>
                            <option value="1">{translations[language].beginner}</option>
                            <option value="2">{translations[language].intermediate}</option>
                            <option value="3">{translations[language].advanced}</option>
                            <option value="4">{translations[language].fluent}</option>
                        </select>
                        <button className="btn btn-primary ms-2 info-button" type="button" onClick={() => setAbilityInfoVisible(!isAbilityInfoVisible)}>i</button>      

                    </div>

                    {isAbilityInfoVisible && (
                        <InfoForm
                            info_num={1}
                            onClose = {() => setAbilityInfoVisible(false)}
                        />
                    )}
                </div>


            

                <div className="form-group mb-3">
                   
                    <span>{translations[language].selectGender}: </span>
                    <select 
                        value={gender} 
                        onChange={(e) => setGender(parseInt(e.target.value, 10))}
                        className="form-input form-control" 
                    >
                    <option value="0">{translations[language].male}</option>
                    <option value="1">{translations[language].female}</option>
                    <option value="2">{translations[language].nonBinary}</option>
                    <option value="3">{translations[language].preferNotToSay}</option>
                    </select>

                </div>

                <div className="form-group mb-4">

                        <span>{translations[language].selectAge}:</span>
                        <select
                            id="ageRange"
                            value={ageRange}
                            onChange={(e) => setAgeRange(e.target.value)}
                            className="form-input form-control" 
                        >
                            <option value="0">16 to 24</option>
                            <option value="1">25 to 34</option>
                            <option value="2">35 to 44</option>
                            <option value="3">45 to 54</option>
                            <option value="4">55 to 65</option>
                            <option value="5">65+</option>
                            <option value="6">{translations[language].preferNotToSay}</option>
                        </select>
                  
                </div>


                <div className="form-group mb-2">
                
                    <div className="form-check">
                        <input
                            className="form-check-input form-input"
                            id="visiting-checkbox"
                            type="checkbox"
                            checked={tourist}
                            onChange={(e) => setTourist(e.target.checked)}
                        />
                        <span className="form-check-label" htmlFor="visiting-checkbox">{translations[language].visiting}?</span>
                    </div> 
                </div>


                <div className="form-group mb-4">
                    <div className="form-check">
                        <input
                            className="form-check-input form-input"
                            type="checkbox"
                            id="consent"
                            checked={consent}
                            onChange={(e) => setConsent(e.target.checked)}
                        />
                        <span className="form-check-label" htmlFor="consent">{translations[language].termsAndConditionsIntro} <a href="https://gaelicconnect.info/privacy/">{translations[language].termsAndConditions}</a></span>
                    </div>
                </div>

        


                <div className="form-group">
                 
                    <div className="sign-up-form-header">
                        <h3>{translations[language].labels}</h3>
                        <button className="btn btn-primary info-button" type="button" onClick={() => setLabelInfoVisible(!isLabelInfoVisible)}>i</button>
                    </div>


                    {isLabelInfoVisible && (
                        <InfoForm
                            info_num={2}
                            onClose = {() => setLabelInfoVisible(false)}
                        />
                    )}
                
                    <div className="form-group mb-3">
                        {predefinedLabels.map((label, index) => (
                            <div className="form-check ms-2">
                                <input
                                    type="checkbox"
                                    className="form-check-input form-input"
                                    value={label}
                                    onChange={handleLabelChange}
                                />
                                <span key={index} className="checkbox-label">{label}</span>
                            </div>
                        ))}

                        {labels && labels.map((label, index) => (
                            <>
                            {!predefinedLabels.includes(label) && (
                                <div className="form-check ms-2">
                                    
                                    <input
                                        type="checkbox"
                                        checked
                                        className="form-check-input form-input"
                                        value={label}
                                        onChange={handleLabelChange}
                                    />
                                    <span key={index} className="checkbox-label">{label}</span>
                                    
                                </div>
                            )}
                            </>
                        ))}
                
                    </div>

                </div>

                <div className="form-group mb-4">
                    <div className="sign-up-form-header">
                    <input
                        type="text"
                        id="label-input"
                        placeholder={translations[language].enterLabel}
                        value={customLabel}
                        onChange={(e) => setCustomLabel(e.target.value)}
                        className="form-input form-control text-center"
                    />

                    <button type="button" className="btn btn-primary ms-2 label-button"  onClick={addCustomLabel}>
                        {translations[language].addLabel}
                    </button>

                    </div>
                </div>

                <div>
                    
                    <button onClick={onClose} className="btn btn-danger form-action-button me-2" >{translations[language].cancel}</button>
                    <button type="submit" className="btn btn-primary form-action-button">{translations[language].signUp}</button>
                  
                </div>
           
            
            </form>
          </div>


        </div>
      );
    }
    
    export default SignupForm;